var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-text"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" The Goodyear Tire & Rubber Company | "),_c('a',{staticClass:"gy-footer-link",attrs:{"href":"https://corporate.goodyear.com/us/en/more/terms-conditions-and-privacy-policy.html","target":"_blank","rel":"noopener"}},[_vm._v("Terms & Conditions and Privacy Policy")])])
}
var staticRenderFns = []

export { render, staticRenderFns }